<template>
  <div v-if="!isLoading" class="spl-daily-cargo-table">
    <h3>Total Parcels: {{ parcels }}, Total Weight: {{ weight }}, Total Volume: {{ volume }}</h3>
    <br>
    <table>
      <thead>
        <tr class="spl-daily-cargo-table__head">
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index"
            @click="toggleSort(header.name)">
            <span
              v-if="findSort(sortedFields, header.name)"
              :class="findSort(sortedFields, header.name).direction"
              class="order-arrow" />
            {{ header.label }}
          </th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(dailyCargo, dailyCargoIndex) in sortedDailyCargoData"
          :key="'dailyCargoTable' + dailyCargoIndex">
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
            :class="{'spl-daily-cargo-table__field--number': isNumber(dailyCargo[field.name]),
                     'spl-daily-cargo-table__field--long': field.long,
                     'spl-daily-cargo-table__field--bold': field.bold}">
            <span>
              {{ formatField(dailyCargo[field.name], field.name, field.type) }}
            </span>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="editData(dailyCargo)">
              <img src="../../../assets/icon-edit.svg">
            </form-button>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="goToParcels(dailyCargo)">
              <img src="../../../assets/icon-search.svg">
            </form-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="spl-daily-cargo-table__buttons">
      <div style="grid-column: 6; grid-row: 1;">
        <form-button
          :disabled="isManifestGenerated()"
          @onClick="generateManifest">
          Save Final Version
        </form-button>
      </div>
      <div v-if="selectedRoute === constants.FLIGHT_ID.FKB_JKG" style="grid-column: 5; grid-row: 1;">
        <form-button
          :disabled="dailyCargoRacValidation.length < 1"
          @onClick="generateSummary">
          Generate Summary
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { find, findIndex, orderBy, isNumber } from 'lodash'
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      sortedFields: [],
      parcels: 0,
      weight: 0,
      volume: 0,
      tableFields: [
        { name: 'Customer_Name', label: 'Customer', type: 'String' },
        { name: 'Country_Name', label: 'Destination country', type: 'String' },
        { name: 'PostalCode_From', label: 'Postal Code From', type: 'String' },
        { name: 'PostalCode_To', label: 'Postal Code To', type: 'String' },
        { name: 'Nr_Parcels', label: 'Total pieces', type: 'String' },
        { name: 'Weight', label: 'Weight', type: 'String' },
        { name: 'Volume', label: 'Volume', type: 'String' },
        { name: 'DGR_Nr_Parcels', label: 'DGR Total pieces', type: 'String' },
        { name: 'DGR_Weight', label: 'DGR Weight', type: 'String' },
        { name: 'DGR_Volume', label: 'DGR Volume', type: 'String' },
        { name: 'Offload_Nr_Parcels', label: 'Total offloaded pieces', type: 'String' },
        { name: 'Offload_Weight', label: 'Offloaded Weight', type: 'String' },
        { name: 'Offload_Volume', label: 'Offloaded Volume', type: 'String' },
        { name: 'EAD_Count', label: 'EAD Count', type: 'String' },
        { name: 'Invoice_Group', label: 'Invoice Group', type: 'String' }
      ],
      constants
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoData', 'dailyCargoRacValidation', 'selectedRoute']),
    sortedDailyCargoData: function () {
      function compareCustomerName (a, b) {
        if (a.Customer_Name < b.Customer_Name) return -1
        if (a.Customer_Name > b.Customer_Name) return 1
        return 0
      }
      function compareCountryName (a, b) {
        if (a.Country_Name < b.Country_Name) return -1
        if (a.Country_Name > b.Country_Name) return 1
        return 0
      }
      return this.dailyCargoData
        .filter(d => d.Customer_Name !== '')
        .sort(compareCountryName)
        .sort(compareCustomerName)
    }
  },
  watch: {
    dailyCargoData: {
      handler: function () {
        const total_parcel = []
        const total_weight = []
        const total_volume = []
        const offloaded_parcel = []
        const offloaded_weight = []
        const offloaded_volume = []
        Object.entries(this.dailyCargoData).forEach(([key, val]) => {
          total_parcel.push(val.Nr_Parcels)
          total_weight.push(val.Weight)
          total_volume.push(val.Volume)
          offloaded_parcel.push(val.Offload_Nr_Parcels)
          offloaded_weight.push(val.Offload_Weight)
          offloaded_volume.push(val.Offload_Volume)
        })
        this.parcels = total_parcel.reduce((acc, n) => acc + n, 0) -
                       offloaded_parcel.reduce((acc, n) => acc + n, 0)
        this.weight = total_weight.reduce((acc, n) => acc + n, 0) -
                       offloaded_weight.reduce((acc, n) => acc + n, 0)
        this.volume = total_volume.reduce((acc, n) => acc + n, 0) -
                       offloaded_volume.reduce((acc, n) => acc + n, 0)
      },
      deep: true
    }
  },
  methods: {
    editData (dailyCargo) {
      this.$router.push({ name: 'daily-cargo-data-edit', params: dailyCargo })
    },
    isManifestGenerated () {
      return this.dailyCargoRacValidation.length < 1
    },
    goToParcels (dailyCargo) {
      const selectedOptions = {
        from_date: new Date(),
        to_date: new Date(),
        customer_id: dailyCargo.Customer_ID,
        country_id: dailyCargo.Country_ID,
        service_level_id: -1,
        status: -1,
        current_event_infos: -1,
        show_forward_flow: true,
        from_postal_code: '',
        to_postal_code: '',
        providers: -1,
        tags: -1
      }
      this.$router.push({ name: 'parcel-list', params: selectedOptions })
    },
    toggleSort (field) {
      const sortedField = find(this.sortedFields, { field })
      if (sortedField) {
        if (sortedField.direction === 'asc') {
          sortedField.direction = 'desc'
        } else {
          this.sortedFields.splice(findIndex(this.sortedFields, { field }))
        }
      } else {
        this.sortedFields.push({ direction: 'asc', field })
      }
      this.sortData()
    },
    sortData () {
      let sortFields = []
      let sortDirections = []
      for (let i = 0; i < this.sortedFields.length; i++) {
        const sortElement = this.sortedFields[i]
        sortFields.push(sortElement.field)
        sortDirections.push(sortElement.direction)
      }
      if (sortFields.length === 0) {
        sortFields = [constants.REFERENCE_TYPE_NAME.COUNTER_NUMBER]
        sortDirections = ['asc']
      }
      this.reportList = orderBy(this.reportList, sortFields, sortDirections)
    },
    formatField (field, name, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      if (name === 'Volume' || name === 'DGR_Volume' || name === 'Offload_Volume') {
        return this.numberFormat(field, 3, true)
      } else if (name === 'Weight' || name === 'DGR_Weight' || name === 'Offload_Weight') {
        return this.numberFormat(field, 2, true)
      } else if (name === 'Nr_Parcels' || name === 'DGR_Nr_Parcels' || name === 'Offload_Nr_Parcels' || name === 'EAD_Count') {
        return this.numberFormat(field)
      }
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    findSort (array, value) {
      return find(array, { field: value })
    },
    isNumber (value) {
      return isNumber(value)
    },
    generateManifest () {
      this.generateManifestDocument(this.dailyCargoData, 'Manifest.pdf', 'manifest')
      this.$forceUpdate()
    },
    generateSummary () {
      this.generateManifestDocument(this.dailyCargoData, 'Summary.pdf', 'summary')
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .spl-daily-cargo-table {
    &__edit {
      background-color: $footerButtonYellow;
      color: $yellowButtonLabel;
      height: 24px;
      margin: 0 0 0 0 !important;
    }

    margin: 0 70px;
    width: calc(100% - 138px);
    height: calc(100vh - 245px);
    overflow: auto;

    &__buttons {
      display: grid;
      grid-template-columns: 16% 16% 16% 16% 16% 16%;
      width: 75%;
      float: right;
      div {
        margin-bottom: 5px;
        margin-top: 20px;
      }
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
}
</style>
